import { Component, ElementRef, ViewChild } from '@angular/core';
import { mainMapMngr } from '../asp/MapMngr';
import { FreeDrawingsPool, FreeDrawingObject } from '../asp/free-drawings';
import { AspObject } from '../asp/AspObject';
import { ColorPickerService } from '../common/color-picker/color-picker.service';
import * as settings from '../common/settings';
import * as consts from '../common/consts';
import { ColorPickerComponent } from '@core_n/common/color-picker/color-picker.component';

const ERASE_CUROSR = 'url(/assets/Images/ic_delete_white_24dp.png) 12 12, auto';

//
// Free Drawing Bar
//
@Component({
  templateUrl: './free-draw-bar.component.html',
  styleUrls: ['./menu-bars.scss']
})
export class FreeDrawBarComponent {

  readonly TOOL_NONE = 0;
  readonly TOOL_PENCIL = 1;
  readonly TOOL_BRUSH = 2;
  readonly TOOL_RECTANGLE = 3;
  readonly TOOL_CIRCLE = 4;
  readonly TOOL_ERASE = 5;
  readonly TOOL_COLOR = 6;
  readonly TOOL_POLYGON = 7;

  private visible: boolean = false;

  private toolsGeometry: Map<any, any> = new Map();
  private activeTool: number = this.TOOL_NONE;
  private defaultStyleColor: string;
  private currentColor: string;

  @ViewChild('colorButton', { read: ElementRef }) private colorButton: ElementRef;

  constructor(private colorPickerSvc: ColorPickerService) {
    this.toolsGeometry.set(this.TOOL_PENCIL, NeWMI.Geometry.Enums.EGeometryType.Multipoint);
    this.toolsGeometry.set(this.TOOL_BRUSH, NeWMI.Geometry.Enums.EGeometryType.Multipoint);
    this.toolsGeometry.set(this.TOOL_RECTANGLE, NeWMI.Geometry.Enums.EGeometryType.Rectangle);
    this.toolsGeometry.set(this.TOOL_CIRCLE, NeWMI.Geometry.Enums.EGeometryType.Circle);
    this.toolsGeometry.set(this.TOOL_POLYGON, NeWMI.Geometry.Enums.EGeometryType.Polygon);

    let style = getComputedStyle(document.body);
    this.defaultStyleColor = style.getPropertyValue('--default-color');

    this.currentColor = settings.userSettings.freeDrawColor ? settings.userSettings.freeDrawColor : ColorPickerComponent.defaultColor();
  }

  colorPickerIconColor() {
    return `linear-gradient(${this.currentColor}, ${this.defaultStyleColor})`;
  }

  toggleVisible() {
    this.visible = !this.visible;
    if (!this.visible && this.activeTool != this.TOOL_NONE)
      this.deactivateTool();
  }

  isColorPickerActive() {
    return this.colorPickerSvc.isColorPickerShown();
  }

  public isFreeDrawDisabled() {
    return (!mainMapMngr.defaultToolActive() && this.activeTool == this.TOOL_NONE);
  }

  public isToolActive(tool) {
    return this.activeTool == tool;
  }

  async onColorClick() {
    let color = await this.colorPickerSvc.showColorPicker(this.colorButton, this.currentColor);
    if (color) {
      this.currentColor = color;
      settings.userSettings.setFreeDrawColor(color);
    }
  }

  onPencilClick() {
    this.activateTool(this.TOOL_PENCIL);
  }

  onBrushClick() {
    this.activateTool(this.TOOL_BRUSH);
  }

  onRectangleClick() {
    this.activateTool(this.TOOL_RECTANGLE);
  }

  onCircleClick() {
    this.activateTool(this.TOOL_CIRCLE);
  }

  public onEraserClick() {
    this.activateTool(this.TOOL_ERASE);
  }

  onPolygonClick() {
    this.activateTool(this.TOOL_POLYGON);
  }

  isVisible() {
    return this.visible;
  }

  private activateTool(tool) {
    let activate = !this.isToolActive(tool);
    this.deactivateTool();
    if (activate) {
      if (tool == this.TOOL_ERASE)
        mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this),
          [NeWMI.Map.Enums.EMapEvents.MouseDown, NeWMI.Map.Enums.EMapEvents.MouseDrag], ERASE_CUROSR);
      else
        mainMapMngr.activateCreateTool(this.toolsGeometry.get(tool), this.onCreateToolFinish.bind(this), true /* multi shape */);
      this.activeTool = tool;
    }
  }

  private onCreateToolFinish(geometry: any) {
    // make sure free drawings are visible
    if (!settings.userSettings.mapElementsOn[consts.MAP_DISPLAY_ELEMENT_FREE_DRAWINGS])
      settings.userSettings.toggleMapElementOn(consts.MAP_DISPLAY_ELEMENT_FREE_DRAWINGS);

    FreeDrawingsPool.getSelf().createFreeDrawing(geometry, this.currentColor, this.activeTool == this.TOOL_BRUSH);
    mainMapMngr.redrawMap();
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    if (evt.button == 0) {
      mainMapMngr.getMap().setNavigationMode({ pan: false });
      let drawingsToDelete: AspObject[] = mainMapMngr.objectsAtLocation(evt.mapPoint, false, mainMapMngr.freeDrawingsDrawer);
      if (drawingsToDelete && drawingsToDelete.length) {
        for (let drawing of drawingsToDelete)
          FreeDrawingsPool.getSelf().deleteFreeDrawing(drawing as FreeDrawingObject);
      }
    }
  }
  
  private deactivateTool() {
    this.activeTool = this.TOOL_NONE;
    mainMapMngr.activateDefaultTool();
  }
}
